var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state)?_c('Onboarder',{attrs:{"initialState":_vm.state,"print":true,"locale":_vm.locale,"integrations":_vm.integrations}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }